// Global constants

export const ANNO_USER_ID = 'annoUserId'
